module.exports = __webpack_public_path__ + "paypal-badge.ae1ce464812f4ba53f368c8c388cdc8e.svg";